<div class="flex flex-col h-full">
    <!-- Comment list -->
    <div #scrollContainer class="flex-1 overflow-y-auto px-6 py-4 flex flex-col gap-6 min-h-0">
        @if (loading()) {
            <div class="flex flex-col gap-3">
                @for (_ of [1, 2, 3]; track $index) {
                    <div class="h-16 rounded-md bg-white/5 animate-pulse"></div>
                }
            </div>
        } @else if (groups().length === 0) {
            <div class="flex flex-col items-center justify-center h-full gap-2 text-shui-text-disabled">
                <sh-icon icon="chat" size="l"></sh-icon>
                <span class="text-sm">{{ 'common.comments.empty' | translate }}</span>
            </div>
        } @else {
            @for (group of groups(); track group.date) {
                <!-- Date separator -->
                <div class="flex items-center gap-3">
                    <hr class="flex-1 border-white/10 m-0" />
                    <span class="text-xs text-shui-text-disabled px-2 border border-white/10 rounded-full py-0.5">
                        {{ group.date }}
                    </span>
                    <hr class="flex-1 border-white/10 m-0" />
                </div>

                <!-- Bubbles -->
                @for (comment of group.comments; track comment.id) {
                    <app-comment-bubble
                        [comment]="comment"
                        [currentUser]="currentUser()"
                        (fileDownload)="onFileDownload($event.commentId, $event.fileName)"
                    ></app-comment-bubble>
                }
            }
        }
    </div>

    <!-- Editor -->
    <div class="flex-shrink-0 px-6 pb-4 pt-2 border-t border-white/10">
        <form [formGroup]="form">
            @if (uploadedFiles().length) {
                <div class="flex flex-wrap gap-2 mb-2 p-2 bg-white/5 rounded-md">
                    @for (file of uploadedFiles(); track file.name) {
                        <span
                            class="flex items-center gap-1 text-xs bg-white/10 rounded-full px-3 py-1 text-shui-text-moderate"
                        >
                            <sh-icon icon="document" size="xs"></sh-icon>
                            <span class="truncate max-w-[160px]">{{ file.name }}</span>
                            <button
                                type="button"
                                class="ml-1 text-shui-text-disabled hover:text-shui-text-strong bg-transparent border-0 cursor-pointer p-0 leading-none"
                                (click)="removePendingFile(file)"
                                [attr.aria-label]="'Remove ' + file.name"
                            >
                                <sh-icon icon="cancel" size="xs"></sh-icon>
                            </button>
                        </span>
                    }
                </div>
            }
            <sh-editor
                formControlName="body"
                [placeholder]="'common.comments.placeholder' | translate"
                (attachments)="onFilesAttached($event)"
            >
                <div toolbarEnd class="flex items-center gap-4">
                    @if (showInternal()) {
                        <div class="flex items-center gap-1 text-sm text-shui-text-subtle">
                            <sh-toggle-accessor formControlName="internal"></sh-toggle-accessor>
                            <sh-icon icon="lock" size="xs"></sh-icon>
                            <span>{{ 'common.request-detail.comments.internal-message' | translate }}</span>
                        </div>
                    }
                    @if (canNotify()) {
                        <div class="flex items-center gap-1 text-sm text-shui-text-subtle">
                            <sh-toggle-accessor formControlName="notifyResponsible"></sh-toggle-accessor>
                            <sh-icon icon="notification-center" size="xs"></sh-icon>
                            <span>{{ 'common.request-detail.comments.notify-responsible' | translate }}</span>
                        </div>
                    }
                </div>
                <div bottomActions class="flex justify-end">
                    <sh-button
                        [label]="'common.comments.send' | translate"
                        [disabled]="!canSend()"
                        size="max-content"
                        icon="send-message"
                        icon-position="start"
                        (click)="onSubmit()"
                    ></sh-button>
                </div>
            </sh-editor>
        </form>
    </div>
</div>
